import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function allTicketDataReducer(state = initialState.allTicketData, action) {
  switch (action.type) {
    case types.LOAD_ALL_TICKET_DATA_SUCCESS:
      return action.allTicketData;
    default:
      return state;
  }
}
